import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { get } from '../../ApiServices/ApiServices';
import Container from '../../Container/Container';
import Loader from '../Component/Loader';
import DeleteButton from '../Component/DeleteFun';
import { useSelector } from 'react-redux';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';

function Customers() {
    const [customers, setCustomers] = useState([]);
    const [SingleCustomers, setSingleCustomers] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isModalLoading, setIsModalLoading] = useState(false);

    // Pagination and Search states
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    // Date range state
    const [dateRange, setDateRange] = useState({
        startDate: null,
        endDate: null,
    });
    const [displayLabel, setDisplayLabel] = useState('');

    const profile = useSelector((state) => state.profile.profile);
    const navigate = useNavigate();

    // Debounce function for search
    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            timeoutId = setTimeout(() => {
                func.apply(null, args);
            }, delay);
        };
    };

    const handleApply = (event, picker) => {
        const startDate = picker.startDate.format('YYYY-MM-DD');
        const endDate = picker.endDate.format('YYYY-MM-DD');

        setDateRange({
            startDate,
            endDate
        });
        setDisplayLabel(`${picker.startDate.format('MMM D, YYYY')} - ${picker.endDate.format('MMM D, YYYY')}`);
        setCurrentPage(1);
        GetCustomers(1, itemsPerPage, search, startDate, endDate);
    };

    const handleCancel = () => {
        setDateRange({
            startDate: null,
            endDate: null
        });
        setDisplayLabel('');
        setCurrentPage(1);
    };

    const GetCustomers = async (
        page_number = currentPage,
        size = itemsPerPage,
        searchTerm = search,
        start = dateRange.startDate,
        end = dateRange.endDate
    ) => {
        try {
            setIsLoading(true);
            let url = `all-customers?page_number=${page_number}&size=${size}`;

            if (searchTerm) {
                url += `&search=${searchTerm}`;
            }
            if (dateRange.startDate && moment(dateRange.startDate).isValid()) {
                url += `&start_date=${moment(dateRange.startDate).format('YYYY-MM-DD')}`;
            }

            if (dateRange.endDate && moment(dateRange.endDate).isValid()) {
                url += `&end_date=${moment(dateRange.endDate).format('YYYY-MM-DD')}`;
            }

            const response = await get(url);


            if (response?.status === true) {
                setCustomers(response?.data?.rows || []);
                setTotalItems(response?.data?.count || 0);
            }
        } catch (err) {
            console.error('Error:', err.message);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const ViewCustomers = async (id) => {
        try {
            setIsModalLoading(true);
            const api = `view-customer/${id}`;
            const response = await get(api);
            if (response?.status === true) {
                setSingleCustomers(response.data);
            }
        } catch (err) {
            if (err?.message === "Invalid or expired token" || err?.message === "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error:', err);
        } finally {
            setIsModalLoading(false);
        }
    };

    const debouncedSearch = useCallback(
        debounce((searchTerm) => {
            GetCustomers(1, itemsPerPage, searchTerm, dateRange.startDate, dateRange.endDate);
        }, 500),
        [itemsPerPage, dateRange.startDate, dateRange.endDate]
    );

    const handleSearch = (e) => {
        const searchTerm = e.target.value;
        setSearch(searchTerm);
        setCurrentPage(1);
        debouncedSearch(searchTerm);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        GetCustomers(page, itemsPerPage, search, dateRange.startDate, dateRange.endDate);
    };

    const handleItemsPerPageChange = (e) => {
        const newLimit = parseInt(e.target.value);
        setItemsPerPage(newLimit);
        setCurrentPage(1);
        GetCustomers(1, newLimit, search, dateRange.startDate, dateRange.endDate);
    };

    const handleDeleteSuccess = (deletedId) => {
        setCustomers(prevCustomers =>
            prevCustomers.filter(customer => customer.id !== deletedId)
        );
        GetCustomers(currentPage, itemsPerPage, search, dateRange.startDate, dateRange.endDate);
    };

    useEffect(() => {
        GetCustomers();
    }, [dateRange]);

    return (
        <>
            <Container>
                {profile?.name === "Admin" && (
                    <div className="nk-content">
                        <div className="container-fluid">
                            <div className="nk-content-inner">
                                <div className="nk-content-body">
                                    <div className="nk-block-head nk-block-head-sm">
                                        <div className="nk-block-between">
                                            <div className="nk-block-head-content">
                                                <h3 className="nk-block-title page-title">Wholesale Stores</h3>
                                            </div>
                                            <div className="nk-block-head-content">
                                                <div className="toggle-wrap nk-block-tools-toggle">
                                                    <div className="toggle-expand-content" data-content="pageMenu">
                                                        {profile?.name === "Admin" && (
                                                            <ul className="nk-block-tools g-3">
                                                                <li className="nk-block-tools-opt" onClick={() => navigate("/create-customers")}>
                                                                    <button className="btn btn-primary">
                                                                        <span>Add Wholesale Store</span>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card card-full">
                                        <div className="card-inner">
                                            <div className="card-title-group mb-3 searchWithDate">
                                                <div className="card-tools customrSearch">
                                                    <div className="form-control-wrap">
                                                        <label className="date-filter-label"></label>
                                                        <div className="form-icon form-icon-right">
                                                            <em className="icon ni ni-search"></em>
                                                        </div>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="default-04"
                                                            placeholder="Search by keywords"
                                                            value={search}
                                                            onChange={handleSearch}
                                                        />
                                                    </div>

                                                    <div className="form-control-wrap">
                                                        <label className="date-filter-label">
                                                            Order Date
                                                        </label>
                                                        <DateRangePicker
                                                            initialSettings={{
                                                                startDate: dateRange.startDate || moment(),
                                                                endDate: dateRange.endDate || moment(),
                                                                locale: {
                                                                    format: 'MMM D, YYYY',
                                                                    cancelLabel: 'Clear',
                                                                    applyLabel: 'Apply',
                                                                },
                                                                ranges: {
                                                                    'Today': [moment(), moment()],
                                                                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                                                                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                                                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                                                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                                                                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                                                                },
                                                                opens: 'right',
                                                                autoApply: true,
                                                                autoUpdateInput: true,
                                                                alwaysShowCalendars: true,
                                                                showCustomRangeLabel: true,
                                                                showCancel: true,
                                                            }}
                                                            onApply={handleApply}
                                                            onCancel={handleCancel}
                                                        >

                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Select date range"
                                                                value={displayLabel}
                                                                readOnly
                                                                disabled={isLoading}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    backgroundColor: '#fff',
                                                                    border: '1px solid #dbdfea',
                                                                    borderRadius: '4px',
                                                                    padding: '0.375rem 0.75rem',
                                                                    minWidth: '142%',
                                                                    paddingRight: '30px',
                                                                    color: '#35495e',
                                                                }}
                                                            />
                                                        </DateRangePicker>
                                                        {displayLabel && (
                                                            <span
                                                                className="clear-icon"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    e.preventDefault();
                                                                    // Find and trigger the cancel button click
                                                                    const cancelBtn = document.querySelector('.daterangepicker .cancelBtn');
                                                                    if (cancelBtn) {
                                                                        cancelBtn.click();
                                                                    } else {
                                                                        handleCancel();
                                                                    }
                                                                }}
                                                                style={{
                                                                    position: 'absolute',
                                                                    right: '-53px',
                                                                    top: '75%',
                                                                    transform: 'translateY(-75%)',
                                                                    cursor: 'pointer',
                                                                    zIndex: 10
                                                                }}
                                                            >
                                                                <em className="icon ni ni-cross"></em>
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {isLoading ? (
                                                <Loader />
                                            ) : (
                                                <>
                                                    <div className="table-responsive">
                                                        <table className="table table-striped mt-3">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Acct#</th>
                                                                    <th scope="col">Account Name</th>
                                                                    <th scope="col">Owner</th>
                                                                    <th scope="col">Phone</th>
                                                                    <th scope="col">Login Email</th>
                                                                    {profile?.name === "Admin" && <th scope="col">Action</th>}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {customers.length > 0 ? (
                                                                    customers.map((data) => (
                                                                        <tr key={data.id}>
                                                                            <td>{data?.account || 'N/A'}</td>
                                                                            <td>{data?.companyName || 'N/A'}</td>
                                                                            <td>{`${data?.firstName || ''} ${data?.lastName || ''}`.trim() || 'N/A'}</td>
                                                                            <td>{data?.phone || 'N/A'}</td>
                                                                            <td>{data?.email || 'N/A'}</td>
                                                                            {profile?.name === "Admin" && (
                                                                                <td className="tableActionBtn">
                                                                                    <button
                                                                                        className="editPen"
                                                                                        // onClick={() => navigate(`/update-customers/${data?.id}`)}
                                                                                        onClick={() => navigate(`/update-customers`, {
                                                                                            state: {
                                                                                                id: data?.id,

                                                                                            }
                                                                                        })}
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        <em className="icon ni ni-edit-alt"></em>
                                                                                    </button>
                                                                                    <button
                                                                                        className="deleteTrash"
                                                                                        data-bs-toggle="modal"
                                                                                        data-bs-target="#viewCusDetailModal"
                                                                                        onClick={() => ViewCustomers(data?.id)}
                                                                                        style={{ cursor: "pointer" }}
                                                                                    >
                                                                                        <em className="icon ni ni-eye"></em>
                                                                                    </button>
                                                                                    <DeleteButton
                                                                                        url={`delete-customer/${data?.id}`}
                                                                                        onDeleteSuccess={() => handleDeleteSuccess(data.id)}
                                                                                    />
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={profile?.name === "Admin" ? 6 : 5} className="text-center">
                                                                            <div className="data-not-found">
                                                                                <em className="icon ni ni-info"></em>
                                                                                <p>No data available</p>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>

                                                    {customers.length > 0 && (
                                                        <div className="nk-block-between-md g-3 mt-3">
                                                            <div className="g">
                                                                <div className="pagination d-flex gap-2" style={{ height: "35px" }}>
                                                                    <button
                                                                        className={`btn btn-sm ${currentPage === 1 ? 'btn-disabled' : 'btn-primary'}`}
                                                                        onClick={() => handlePageChange(currentPage - 1)}
                                                                        disabled={currentPage === 1}
                                                                    >
                                                                        Previous
                                                                    </button>

                                                                    {Array.from({ length: Math.ceil(totalItems / itemsPerPage) }, (_, i) => (
                                                                        <button
                                                                            key={i + 1}
                                                                            className={`btn btn-sm ${currentPage === i + 1 ? 'btn-primary' : 'btn-outline-primary'}`}
                                                                            onClick={() => handlePageChange(i + 1)}
                                                                        >
                                                                            {i + 1}
                                                                        </button>
                                                                    )).slice(
                                                                        Math.max(0, currentPage - 3),
                                                                        Math.min(currentPage + 2, Math.ceil(totalItems / itemsPerPage))
                                                                    )}

                                                                    <button
                                                                        className={`btn btn-sm ${currentPage === Math.ceil(totalItems / itemsPerPage) ? 'btn-disabled' : 'btn-primary'}`}
                                                                        onClick={() => handlePageChange(currentPage + 1)}
                                                                        disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
                                                                    >
                                                                        Next
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {customers.length >= 10 && (
                                                                <div className="g">
                                                                    <div className="pagination-goto d-flex justify-content-center justify-content-md-start gx-3">
                                                                        <div>Showing</div>
                                                                        <div>
                                                                            <select
                                                                                className="form-select js-select2"
                                                                                value={itemsPerPage}
                                                                                onChange={handleItemsPerPageChange}
                                                                            >
                                                                                {totalItems >= 10 && <option value="10">10</option>}
                                                                                {totalItems >= 20 && <option value="20">20</option>}
                                                                                {totalItems >= 50 && <option value="50">50</option>}
                                                                                {totalItems >= 100 && <option value="100">100</option>}
                                                                            </select>
                                                                        </div>
                                                                        <div>of {totalItems} items</div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Container>

            {/* View Customer Modal */}
            <div className="modal fade" tabIndex="-1" id="viewCusDetailModal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content w-100">
                        <div className="modal-header">
                            <h5 className="modal-title">View Store Detail</h5>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body inputCardBox">
                            {isModalLoading ? (
                                <Loader />
                            ) : (
                                <div className="row">
                                    {SingleCustomers && (
                                        <>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>ID:</span>
                                                    <span className="wrap-text">{SingleCustomers?.id || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Acct#:</span>
                                                    <span className="wrap-text">{SingleCustomers?.account || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Company name:</span>
                                                    <span className="wrap-text">{SingleCustomers?.companyName || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Email:</span>
                                                    <span className="wrap-text">{SingleCustomers?.email || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Phone:</span>
                                                    <span className="wrap-text">{SingleCustomers?.phone || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Billing Address:</span>
                                                    <span className="wrap-text">
                                                        {SingleCustomers?.addresses?.[0]?.billingAddress || 'N/A'}
                                                        {SingleCustomers?.addresses?.[0]?.billingCity ? `, ${SingleCustomers.addresses[0].billingCity}` : ''}
                                                        {SingleCustomers?.addresses?.[0]?.billingState ? `, ${SingleCustomers.addresses[0].billingState}` : ''}
                                                        {SingleCustomers?.addresses?.[0]?.billingZip ? ` ${SingleCustomers.addresses[0].billingZip}` : ''}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Owner:</span>
                                                    <span className="wrap-text">
                                                        {`${SingleCustomers?.firstName || ''} ${SingleCustomers?.lastName || ''}`.trim() || 'N/A'}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Alternate Pickup Location:</span>
                                                    <span className="wrap-text">
                                                        {SingleCustomers?.isAltPickupEnable ? "Enabled" : "Disabled"}
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Affiliated store:</span>
                                                    <span className="wrap-text">{SingleCustomers?.affiliatedStore || 'N/A'}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 mb-2">
                                                <div className="detailList">
                                                    <span>Drop Shipping:</span>
                                                    <span className="wrap-text">
                                                        {SingleCustomers?.isDropShipEnable ? "Enabled" : "Disabled"}
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Customers;